import React, {useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import {
    Aux,
    AwningRequiresFabric,
    COLOUR_STANDARD_CUSTOM_ID,
    COLOUR_STANDARD_RIVERSAND_ID,
    COLOUR_STANDARD_TEXTURA_BASS_ID,
    COLOUR_STANDARD_SILVER_ID, COLOUR_STANDARD_SURFMIST_ID,
    CRANK_HANDLE_1400,
    CRANK_HANDLE_1800,
    DRIVE_MECHANISM_MANUAL,
    DRIVE_MECHANISM_MotorisedHardwired,
    DRIVE_MECHANISM_MotorisedRemote, 
    FLASHINGTYPE_Sintesi300,
    FLASHINGTYPE_Sintesi500,
    FLASHINGTYPE_WallSeal,
    INSTALLATION_BRACKET_25_GAL,
    INSTALLATION_BRACKET_25_PC,
    INSTALLATION_BRACKET_TYPE_FASCIA_GAL,
    INSTALLATION_BRACKET_TYPE_FASCIA_PC,
    isGeigerRemote,
    isHardwired,
    isMotionSensor,
    isNullEmptyOrWhitespace,
    IsNullOrUndefined,
    isRemote,
    IsRoofSystem,
    isVarioVolant,
    MOCO_TYPE_3_PIN,
    MOCO_TYPE_HIRSCHMANN,
    MOUNTING_BRACKET_UNIVERSAL,
    PRODUCTGROUPID_FOLDING_ARM,
    PRODUCTID_ECO,
    PRODUCTID_OLYMPUS,
    PRODUCTID_S1,
    PRODUCTID_S3,
    PROJECTIONS_MAX,
    PROJECTIONS_MIN,
    REMOTE_MULTICHANNEL,
    REMOTE_SINGLECHANNEL,
    ROLE_Administrator,
    ROLE_ProductManager,
    SensorTypes,
    SM_FASCIA_BRACKET_ID,
    fabmod_send_po_to_nolans_all,
} from "../../constants";
import RadioControlGroup from "../common/RadioControlGroup";
import TextBoxControl from "../common/TextBoxControl";
import AwningView, {getDefaultAwning, Messages} from "../orders/AwningView";
import {apiDownloadReport, apiPost, apiRequest} from "../../utils/request";
import SelectControl from "../common/SelectControl";
import ColourSelectorControl from "../common/ColourSelectorControl";
import moment from "moment/moment";

class FabricationAwning extends AwningView {
  constructor(props, context) {
    super(props, context);
   
    this.state = {...this.state,
        loadedMotors: false,
    };

    this.fetchMotorOptions = this.fetchMotorOptions.bind(this);
    this.AllowedValance = this.AllowedValance.bind(this);
    this.IncludeValance = this.IncludeValance.bind(this);
    this.groupShortName = this.groupShortName.bind(this);
  }

  // The group FABMOD orders go to (Nolans), supplied by FabricationOrdersEditPage -- matches its groupShortName().
  groupShortName() {
    return this.props.fabmodSupplierShortName || '';
  }

  componentDidUpdate(prevProps, prevState) {
      super.componentDidUpdate(prevProps, prevState);

      // Each block below runs once when its underlying lookup list actually changes
      // (compared against the real previous value of that same state key), filtering
      // it down to the subset relevant to fabrication orders.

      if (this.state.products.length > 0 && this.state.products.length !== prevState.products.length) {
          const products = this.state.products.filter(x => x.id === PRODUCTID_ECO || x.id === PRODUCTID_S3);
          this.setState({
              products: [...products],
          });
      }

      if (this.state.selectedProduct && JSON.stringify(this.state.selectedProduct) !== JSON.stringify(prevState.selectedProduct)) {
          const selectedProduct = {
              ...this.state.selectedProduct,
              maxWidth: 6000,
              ...(this.state.selectedProduct.id === PRODUCTID_S3 && { minWidth: 2420 })
          };

          const widthMessage = {
              ...(this.state.selectedProduct.id === PRODUCTID_S3 && { width: "Please enter width between: 2420 and 6000. For awnings > 6000 please contact Nolans." }),
              ...(this.state.selectedProduct.id === PRODUCTID_ECO && { width: "Please enter width between 1910 and 6000. Invalid order if > 6000" })
          };

          const shouldUpdateWidthMessage = this.state.validationMessages &&
              this.state.validationMessages.width &&
              this.state.validationMessages.width.startsWith("Please enter");

          this.setState({
              validationMessages: shouldUpdateWidthMessage ? {...this.state.validationMessages, ...widthMessage} : this.state.validationMessages,
              selectedProduct: {...selectedProduct},
          });
      }

      if (this.state.projections.length > 0 && this.state.selectedProduct && this.state.selectedProduct.id === PRODUCTID_S3
          && this.state.projections.length !== prevState.projections.length) {
          const projections = this.state.projections.filter(x => x.value >= PROJECTIONS_MIN && x.value <= PROJECTIONS_MAX);
          this.setState({
              projections: [...projections],
          });
      }

      if (this.state.coloursStandard.length > 0 && this.state.selectedProduct && this.state.selectedProduct.id === PRODUCTID_S3
          && this.state.coloursStandard.length !== prevState.coloursStandard.length) {

          const EXCLUDED_COLOUR_IDS = [
              COLOUR_STANDARD_SILVER_ID,
              COLOUR_STANDARD_RIVERSAND_ID,
              COLOUR_STANDARD_CUSTOM_ID,
              COLOUR_STANDARD_TEXTURA_BASS_ID,
          ];
          let coloursStandard = this.state.coloursStandard.filter(x => !EXCLUDED_COLOUR_IDS.includes(x.id));

          // Add Surfmist colour (ID matches ColourId in database)
          if (!coloursStandard.some(color => color.id === COLOUR_STANDARD_SURFMIST_ID)) {
              const surfmistColor = {
                  "colourDescription": "Surfmist (Surfmist 2721137S Satin)",
                  "id": COLOUR_STANDARD_SURFMIST_ID };
              coloursStandard = [...coloursStandard, surfmistColor];
          }

          this.setState({
              coloursStandard: [...coloursStandard],
          });
      }

      if (this.state.driveMechanisms.length > 0 && this.state.driveMechanisms.length !== prevState.driveMechanisms.length) {
          const driveMechanisms = this.state.driveMechanisms.filter(x =>
              x.value === DRIVE_MECHANISM_MANUAL
              || x.value === DRIVE_MECHANISM_MotorisedHardwired
              || x.value === DRIVE_MECHANISM_MotorisedRemote);
          this.setState({
              driveMechanisms: [...driveMechanisms],
          });
      }

      if (this.state.crankHandles.length > 0 && this.state.crankHandles.length !== prevState.crankHandles.length) {
          const crankHandles = this.state.crankHandles.filter(x => x.id === CRANK_HANDLE_1400 || x.id === CRANK_HANDLE_1800);
          this.setState({
              crankHandles: [...crankHandles],
          });
      }

      if (this.state.remotes.length > 0 && this.state.remotes.length !== prevState.remotes.length) {
          const remotes = this.state.remotes.filter(x => x.value === REMOTE_MULTICHANNEL || x.value === REMOTE_SINGLECHANNEL);
          this.setState({
              remotes: [...remotes],
          });
      }

      if (this.state.mountingBrackets.length > 0 && this.state.mountingBrackets.length !== prevState.mountingBrackets.length) {
          const mountingBrackets = this.state.mountingBrackets.filter(x => x.id === MOUNTING_BRACKET_UNIVERSAL);
          this.setState({
              mountingBrackets: [...mountingBrackets],
          });
      }

      if (this.state.installationBracketTypes.length > 0 && this.state.installationBracketTypes.length !== prevState.installationBracketTypes.length) {
          const installationBracketTypes = this.state.installationBracketTypes.filter(x => x.id === INSTALLATION_BRACKET_TYPE_FASCIA_PC || x.id === INSTALLATION_BRACKET_TYPE_FASCIA_GAL);
          this.setState({
              installationBracketTypes: [...installationBracketTypes],
          });
      }

      if (this.state.installationBrackets.length > 0 && this.state.installationBrackets.length !== prevState.installationBrackets.length) {
          const installationBrackets = this.state.installationBrackets.filter(x => x.id === INSTALLATION_BRACKET_25_PC || x.id === INSTALLATION_BRACKET_25_GAL);
          this.setState({
              installationBrackets: [...installationBrackets],
          });
      }

      if (this.state.mocoTypes.length > 0 && this.state.mocoTypes.length !== prevState.mocoTypes.length) {
          const mocoTypes = this.state.mocoTypes.filter(x => x.value === MOCO_TYPE_3_PIN || x.value === MOCO_TYPE_HIRSCHMANN);
          this.setState({
              mocoTypes: [...mocoTypes],
          });
      }

      this.fetchMotorOptions(prevState);
  }
  
  getExcludedValidators() {
    return ['preferredMotorBrandId', 'motorSupplierType'];
  }

  handleColourChange(field, val) {
    let {selectedStandardColourId, selectedCustomColourId} = val;
    let x = {...this.state.awning};
    let newState = {...this.state};
    let isS3FrameChange = field === 'frame'
        && this.state.selectedProduct
        && this.state.selectedProduct.id === PRODUCTID_S3;

    x[`${field}ColourId`] = selectedStandardColourId;
    x[`${field}CustomColourId`] = selectedCustomColourId;

    if (isS3FrameChange) {
      x.pelmetColourId = selectedStandardColourId;
      x.pelmetCustomColourId = selectedCustomColourId;
    }

    let validationMessages = this.getValidationMessages(`${field}ColourId`, {
      selectedStandardColourId,
      selectedCustomColourId
    });

    newState.validationMessages = validationMessages;
    newState.awning = x;

    this.setState(newState, this.raiseAwningChanged);
  }

  showAwningMessages() {
    let {awning, messages, surchargeMessages} = this.state;
    let {siteSettings} = this.props;

    if (awning.width > 7000) {
      messages.add(Messages.AwningWidthJoiners);
    } else {
      messages.delete(Messages.AwningWidthJoiners);
    }

    if (awning.remote == 4) {
      messages.add(Messages.RemoteOther);
    } else {
      messages.delete(Messages.RemoteOther);
    }

    messages.delete(siteSettings.ProductPriceListMessage);
    messages.delete(siteSettings.ProductSintesiPriceListMessage);
    messages.delete(siteSettings.FabricationOrderMessage);

    if (siteSettings.FabricationOrderMessage) {
      messages.add(siteSettings.FabricationOrderMessage);
    }

    let addColourSurcharge = (name) => {
      let field = `${name}CustomColourId`;
      if (awning[field] != null) {
        surchargeMessages.set(field, `Surcharge applies as you have ordered a custom ${name} colour`)
      } else {
        surchargeMessages.delete(field);
      }
    };

    addColourSurcharge('frame');
    addColourSurcharge('pelmet');
    addColourSurcharge('flashing');

    this.setState({messages: new Set(messages), surchargeMessages: new Map(surchargeMessages)}, () => {
      this.props.onMessagesChange(this.state.awning.id, {
        messages: this.state.messages,
        validationMessages: this.state.validationMessages,
        surchargeMessages: this.state.surchargeMessages
      });
    });
  }

  componentDidMount() {
    super.componentDidMount();

  }

  fetchMotorOptions(prevState) {
    let {driveMechanismId, productLookupDataId} = this.state.order.awnings[0];
    let {loadedMotors} = this.state;
      
    if(prevState && (prevState.order.awnings[0].driveMechanismId !== driveMechanismId) 
        || (prevState.order.awnings[0].productLookupDataId !== productLookupDataId)
        || loadedMotors === false){
        this.setState({loadedMotors: true})
        
      if(driveMechanismId <= 0 || productLookupDataId <= 0){
        this.setState({motorOptions: []});
      } else {
        apiRequest(`/api/motors/motoroptions?driveMechanismId=${driveMechanismId}&productLookupDataId=${productLookupDataId}`)
            .then(x => {
                const motorOptions = x.data.length > 0 ? 
                    [...x.data, {id: -1, description: "Other"}] : [];
                this.setState({motorOptions: motorOptions});
            });
      }
    }
  }
  AllowedValance(awning, order = null, selectedProduct = null){
      let requiresFabric = order !== null ? AwningRequiresFabric(order, awning) : true;
      let hasValance = selectedProduct !== null ? this.IncludeValance(selectedProduct, awning) : false;
        
      return requiresFabric && !isVarioVolant(awning) && !IsRoofSystem(awning) && hasValance;
  }

  IncludeValance(selectedProduct, awning) {
      return ((selectedProduct !== null && selectedProduct.includeValance === 1) || 
          (selectedProduct !== null && selectedProduct.includeValance === 2 && awning.oversquare))
  }
    

  render() {

    let {awning, validationMessages, order, selectedProduct, motorOptions} = this.state;
    let driveMechanisms = this.state.driveMechanisms;
    let awningRequiresFabric = true;
    let isRoofingSystem = IsRoofSystem(this.state.awning);
    let selectedFabric = (awning.fabricId && this.state.fabrics) ? this.state.fabrics.find(x => x.id === awning.fabricId) : null;
    let pelmetName = (selectedProduct && selectedProduct.hasPelmet) ? 'Cassette Profile' : 'Pelmet';
    
    return (
      <div>
        
        <RadioControlGroup
          style={{marginLeft: '0px'}}
          name={`productGroupId_${awning.id}`}
          onChange={(x, e) => {
            this.handlFieldChangeWithAwningId(e, (v, newState) => {
              return {
                ...newState,
                awning: {...getDefaultAwning(newState.awning), productId: null, projection: 0,},
                selectedProduct: null,
                products: [],
                installationBrackets: [],
                flashingOptions: [],
                installationBracketTypes: [],
              };
            }, "number")
          }}
          value={awning.productGroupId}
          labelText='Product Group'
          validationMessages={validationMessages}
          options={this.state.productGroups.filter(x => x.value === PRODUCTGROUPID_FOLDING_ARM)}
        />

        <RadioControlGroup
            style={{marginLeft: '0px'}}
            name={`productId_${awning.id}`}
            valueKey={'id'}
            labelKey={'description'}
            onChange={(val, e) => this.handleRadioChangeWithAwningId(val, e, (v) => v.objectValue.id, 'selectedProduct', (v, newState) => {
              const defaultAwning = {...getDefaultAwning(newState.awning)};
              return {
                ...newState,
                awning: {
                  ...defaultAwning,
                  ...(v.objectValue.id === PRODUCTID_S3 && newState.awning.width < 2420 ? {width: ""} : {})
                },
                installationBrackets: [],
                flashingOptions: [],
                installationBracketTypes: [],
                remoteColours: [],
                remotes: [],
              };
            })}
            value={awning.productId}
            labelText='Product'
            validationMessages={validationMessages}
            options={this.state.products}
        />

        {awning.productId > 0 && isNullEmptyOrWhitespace(awning.fieldConfiguration) &&
            <TextBoxControl
                style={{marginLeft: '0px'}}
                isDebounce={true}
                debounceeTimeOut={300}
                onChange={(e) => this.handlFieldChange(e, (v, newState) => {
                  return {
                    ...newState, awning: {
                      ...newState.awning,
                      projection: null,
                    }
                  };
                  return newState;
                })}
                labelText="Width"
                value={awning.width.toString()}
                name="width"
                type="number"
                validationMessages={validationMessages}
            />
        }

        {selectedProduct && !selectedProduct.fixedProjection ?
            <TextBoxControl
                style={{marginLeft: '0px'}}
                isDebounce={true}
                debounceeTimeOut={300}
                onChange={this.handlFieldChange}
                labelText="Projection (is back of headbox to end of guiderail)"
                value={awning.projection ? awning.projection.toString() : ''}
                name="projection"
                type="number"
                validationMessages={validationMessages}
            /> :
            <RadioControlGroup
                style={{marginLeft: '0px'}}
                name={`projection_${awning.id}`}
                onChange={(x, e) => this.handlFieldChangeWithAwningId(e, null, "number")}
                value={awning.projection}
                labelText='Projection'
                validationMessages={validationMessages}
                options={this.state.projections}
            />
        }

        <RadioControlGroup
            name={`driveMechanismId_${awning.id}`}
            onChange={(x, e) => this.handlFieldChangeWithAwningId(e, (v, newState) => {
              return {
                ...newState, awning: {
                  ...newState.awning,
                  automationCableId: null,
                  automationSensorType: null,
                  mocoType: null,
                  motorId: null,
                  wallSwitch: isHardwired(newState.awning) ? 'Wall Switch' : null,
                }
              };
            }, "number")}
            value={awning.driveMechanismId}
            labelText='Drive Mechanism'
            validationMessages={validationMessages}
            options={driveMechanisms}
            clearSelectionText={awning.number > 1 ? 'Same as awning 1' : ''}
            onClearSelection={awning.number > 1 ? (e) => this.setDriveSameAsAwning(e, 1) : undefined}
            style={{marginLeft: '0px'}}
        />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`crankHandleId_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, null, "number")}
              value={awning.crankHandleId}
              labelText="Crank Handle"
              validationMessages={validationMessages}
              options={this.state.crankHandles}
              valueKey={'id'}
              labelKey={'description'}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`sideOfOperation_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e)}
              value={awning.sideOfOperation}
              labelText='Side of Operation'
              validationMessages={validationMessages}
              options={this.state.sideOfOperations}
              visible={IsNullOrUndefined(awning.fieldConfiguration) && awning.productLookupDataId > 0}
          />

        { motorOptions && motorOptions.length > 0 &&
            <RadioControlGroup
                style={{marginLeft: '0px'}}
                name={`motorId_${awning.id}`}
                onChange={(x, e) => {
                    this.handlFieldChangeWithAwningId(e)
                 }
                }
                value={awning.motorId}
                labelText="Available Motor Options"
                validationMessages={validationMessages}
                options={motorOptions}
                valueKey={'id'}
                labelKey={'description'}
            />
        }

          {!IsNullOrUndefined(awning.motorId) && awning.motorId === -1 &&
              <div className="form-group">
                  <label style={{color: '#ae2128'}}><i className={'fa fa-exclamation-triangle'}/> Customer to check Roller cutting deductions for Other motor brand</label>
              </div>
          }
        

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`remote_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, (v, newState) => {
                  if (v !== REMOTE_MULTICHANNEL) {
                      return {...newState, awning: {...newState.awning, remoteParentAwningNumber: null}};
                  }
                  return newState;
              }, "number")}
              value={awning.remote}
              labelText="Remote Controls"
              validationMessages={validationMessages}
              options={!IsNullOrUndefined(awning.fieldConfiguration) && awning.fieldConfiguration.numberOfFields > 1 ? this.state.remotes.filter(x => x.value === REMOTE_MULTICHANNEL) : this.state.remotes}
              visible={this.state.remotes.length > 0 && isNullEmptyOrWhitespace(awning.automationSensorType)}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`desiredRemoteColour_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e)}
              value={awning.desiredRemoteColour}
              labelText="Remote colour"
              validationMessages={validationMessages}
              options={this.state.remoteColours}
              visible={this.state.remoteColours.length > 0 && isNullEmptyOrWhitespace(awning.automationSensorType)}
          />

          <ColourSelectorControl
              radioStyle={{marginLeft: '0px'}}
              name={'frameColourId'}
              onChange={(val) => this.handleColourChange('frame', val)}
              label='Frame'
              customColours={this.state.coloursCustom}
              standardColours={this.state.coloursStandard}
              selectedStandardColourId={awning.frameColourId}
              selectedCustomColourId={awning.frameCustomColourId}
              validationMessages={validationMessages}
              disabled={false}
              awningId={awning.id}
              linkText={awning.number > 1 ? 'Same as awning 1' : ''}
              onLink={awning.number > 1 ? (e) => this.setColourSameAsAwning(e, 1) : undefined}
              singleColourSelection={selectedProduct ? selectedProduct.singleColourSelection : null}
              removeDiscontinuedMessage={true}
          />

          {this.state.selectedProduct !== null &&
              <ColourSelectorControl
                  radioStyle={{marginLeft: '0px'}}
                  disabled={!awning.includePelmet}
                  onChange={(val) => this.handleColourChange('pelmet', val)}
                  label={pelmetName}
                  customColours={this.state.coloursCustom}
                  standardColours={this.state.coloursStandard}
                  selectedStandardColourId={awning.pelmetColourId}
                  selectedCustomColourId={awning.pelmetCustomColourId}
                  name={'pelmetColourId'}
                  validationMessages={validationMessages}
                  awningId={awning.id}
                  frameStandardColourId={awning.frameColourId}
                  frameCustomColourId={awning.frameCustomColourId}
                  onlyFrameColour={this.state.selectedProduct.id === PRODUCTID_S3}
              />
          }

          {(awning.productId === PRODUCTID_ECO || awning.productId === PRODUCTID_S1) &&
              <RadioControlGroup
                  style={{marginLeft: '0px'}}
                  name={`hasColorbondHood_${awning.id}`}
                  onChange={(x, e) => {
                      this.handlFieldChangeWithAwningId(e, (v, n) => {
                          let boolVal = x.simpleValue;
                          return {
                              ...n, awning: {
                                  ...n.awning,
                                  hasColorbondHood: boolVal,
                                  colorbondHoodColourId: boolVal ? n.awning.colorbondHoodColourId : null,
                                  includePelmet: boolVal ? false : n.awning.includePelmet,
                                  pelmetColourId: boolVal ? null : n.awning.pelmetColourId,
                                  pelmetCustomColourId: boolVal ? null : n.awning.pelmetCustomColourId,
                                  pelmetType: boolVal ? null : n.awning.pelmetType,
                              }
                          };
                      })
                  }}
                  value={awning.hasColorbondHood}
                  labelText={'FAA Colorbond Hood'}
                  validationMessages={validationMessages}
                  options={this.state.pelmetOptions}
                  visible={true}
              />
          }

          {awning.hasColorbondHood && this.props.user.hasAccessTag(fabmod_send_po_to_nolans_all) &&
              <div style={{color: '#ae2128', marginBottom: '10px'}}>
                  <i className={'fa fa-exclamation-triangle'}/>&nbsp;Colorbond hood needs to be sourced independently of {this.groupShortName()}
              </div>
          }

          {awning.hasColorbondHood &&
              <div className="alert alert-info" role="alert" style={{marginLeft: '-15px'}}>
                  <i className={'fa fa-info-circle'}/> Colorbond Hood length is 20mm greater than awning width
              </div>
          }

          {(awning.productId === PRODUCTID_ECO || awning.productId === PRODUCTID_S1) && awning.hasColorbondHood &&
              <SelectControl
                  validationMessages={validationMessages}
                  labelText="Colorbond Hood Colour"
                  name="colorbondHoodColourId"
                  options={this.state.colorbondColours}
                  simpleValue={true}
                  onChange={(val) => this.handleSelectChange('colorbondHoodColourId', val, (v) => v)}
                  value={awning.colorbondHoodColourId}
                  placeholder="Select Colorbond Colour"
                  valueKey={'value'}
                  labelKey={'label'}
              />
          }

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`flashingType_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, (v, n) => {
                  let boolVal = v > 0;
                  return {
                      ...n, awning: {
                          ...n.awning,
                          flashingColourId: boolVal ? n.awning.frameColourId : null,
                          flashingCustomColourId: boolVal ? n.awning.frameCustomColourId : null,
                          awningFlashing: {
                              ...this.state.awning.awningFlashing,
                              height: v === 1 ? 130 : 0
                          }
                      }
                  };
              }, "number")
              }
              value={awning.flashingType}
              labelText='Include Flashing'
              validationMessages={validationMessages}
              options={this.state.flashingOptions}
          />

          {awning.flashingType > 0 && this.props.user.hasAccessTag(fabmod_send_po_to_nolans_all) &&
              <div style={{color: '#ae2128', marginBottom: '10px'}}>
                  <i className={'fa fa-exclamation-triangle'}/>&nbsp;Flashing needs to be sourced independently of {this.groupShortName()}
              </div>
          }

          {(awning.flashingType === 2) &&
              <div className="form-group">
                  <label style={{color: '#ae2128'}}><i className={'fa fa-exclamation-triangle'}/> Please send details to
                      {this.props.theme.data.text.shortName}</label>
              </div>}

          {parseInt(awning.flashingType) === 1 && <TextBoxControl
              name={`flashingHeight_${awning.id}`}
              onChange={(x) => {
                  let v = parseInt(x.target.value);
                  if (v > 0 && v <= 420) {
                      this.setState({
                          awning: {
                              ...this.state.awning,
                              awningFlashing: {...this.state.awning.awningFlashing, height: v},
                          }
                      }, this.raiseAwningChanged);
                  }
              }}
              labelText="Flashing Height (standard 130 max. 420)"
              value={awning.awningFlashing.height.toString()}
              type="number"
              image={`/img/powder_coating_sheet/FA_FLASH.png`}
          />}

          {parseInt(awning.flashingType) === FLASHINGTYPE_WallSeal &&
              <div className="form-group">
                  <img
                      src={`/img/powder_coating_sheet/${this.state.awning.productId === PRODUCTID_OLYMPUS ? 'OL_SEAL' : 'DS_SEAL'}.png`}
                      style={{paddingLeft: '10px', width: '100px', marginLeft: '-10px'}}/>
              </div>
          }

          <ColourSelectorControl
              radioStyle={{marginLeft: '0px'}}
              disabled={awning.flashingType == null || awning.flashingType == 0}
              onChange={(val) => this.handleColourChange('flashing', val)}
              label='Flashing'
              customColours={this.state.coloursCustom}
              standardColours={this.state.coloursStandard}
              selectedStandardColourId={awning.flashingColourId}
              selectedCustomColourId={awning.flashingCustomColourId}
              name={'flashingColourId'}
              validationMessages={validationMessages}
              awningId={awning.id}
              frameStandardColourId={awning.frameColourId}
              frameCustomColourId={awning.frameCustomColourId}
              onlyFrameColour={awning.flashingType === FLASHINGTYPE_WallSeal
                  || awning.flashingType === FLASHINGTYPE_Sintesi300
                  || awning.flashingType === FLASHINGTYPE_Sintesi500}
              colorBondColourLookup={true}
          />

          <SelectControl
              style={{marginLeft: '0px'}}
              validationMessages={validationMessages}
              labelText="Fabric Brand"
              disabled={!awningRequiresFabric}
              name="fabricBrandId"
              options={this.state.fabricBrands}
              simpleValue={true}
              onChange={(val) => this.handleSelectChange('fabricBrandId', val, (v) => v)}
              value={awning.fabricBrandId}
              placeholder="Select Fabric Brand"
              valueKey={'id'}
              labelKey={'description'}
              toolTip={"Soltis / Mesh PVC fabrics cannot be used on awnings where a cradle is fitted due to increased risk of marking or damage to the fabric. Aluxor will not warrant awnings fitted with fabrics out of specifications"}
          />

          {!IsNullOrUndefined(awning.fabricBrandId) && this.state.fabricBrands && this.state.fabricBrands.filter(x => x.id === awning.fabricBrandId && x.notRecommended).length > 0 &&
              <div className="form-group">
                  <label style={{color: '#ae2128'}}><i className={'fa fa-exclamation-triangle'}/> This Fabric is NOT RECOMMENDED with this product</label>
              </div>
          }

          {!IsNullOrUndefined(awning.fabricBrandId) && this.state.fabricBrands && this.state.fabricBrands.filter(x => x.id === awning.fabricBrandId && x.surcharge > 0).length > 0 &&
              <div className="form-group">
                  <label style={{color: '#ae2128'}}><i className={'fa fa-exclamation-triangle'}/> A surcharge applies to this fabric</label>
              </div>
          }

          <SelectControl
              style={{marginLeft: '0px'}}
              validationMessages={validationMessages}
              labelText="Fabrics"
              disabled={!awningRequiresFabric}
              name="fabricId"
              options={this.state.fabrics}
              simpleValue={true}
              onChange={(val) => this.handleSelectChange('fabricId', val, (v) => v)}
              value={awning.fabricId}
              valueKey={'id'}
              labelKey={'description'}
              placeholder="Select Fabric"
          />
          
          { (selectedFabric && !selectedFabric.isStocked) &&
              <div className="form-group">
                  <label style={{color: '#ae2128'}}><i className={'fa fa-exclamation-triangle'}/> Fabric not stocked in Australia. Available on request.</label>
              </div>
          }

          { (selectedFabric && selectedFabric.isSupplierOutOfStock) &&
              <div className="form-group">
                  <label style={{color: '#ae2128'}}><i className={'fa fa-exclamation-triangle'}/> Fabric is currently out of stock at supplier{selectedFabric.expectedStockDate ? ', expected ' + moment(selectedFabric.expectedStockDate).format('MMM Do') : ', expected date unknown'}</label>
              </div>
          }


          
          {this.state.fabrics && this.state.fabrics.length > 0 && (
              <TextBoxControl
                  onChange={e => this.setState({
                      awning: {
                          ...this.state.awning,
                          fabricNote: e.target.value,
                      }
                  }, this.raiseAwningChanged)}
                  
                  labelText="Fabric Note (optional)"
                  value={awning.fabricNote}
                  name="fabricNote"
                  validationMessages={validationMessages}
              />
          )}
          
          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`fabricValance_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, (v, n) => {
                  return {
                      ...n, awning: {
                          ...n.awning,
                          trimBiasColourId: null,
                      }
                  }}, "number")}
              labelText="Valance"
              validationMessages={validationMessages}
              options={this.state.valances}
              visible={this.AllowedValance(awning, order, selectedProduct)}
              value={awning.fabricValance}
              toolTip={"Valance depth: 180mm for standard and 210mm for oversquare"}
          />

          <SelectControl
              validationMessages={validationMessages}
              labelText="Trim Bias Colour"
              name="trimBiasColourId"
              options={this.state.trimBiasColours}
              simpleValue={true}
              onChange={(val) => this.handleSelectChange('trimBiasColourId', val, (v) => v)}
              value={awning.trimBiasColourId}
              placeholder="Select Trim Bias Colour"
          />

          {awning.productId > 0 && <RadioControlGroup
              name={`mountingBracketId_${awning.id}`}
              style={{marginLeft: '0px'}}
              onChange={(x, e) => {
                  this.setState({
                      awning: {
                          ...this.state.awning,
                          mountingBracketWidth: x.objectValue.width,
                          mountingBracketDescription: x.objectValue.description
                      }
                  }, () => {
                      this.handlFieldChangeWithAwningId(e);
                  });
              }}
              labelText="Mounting Bracket"
              validationMessages={validationMessages}
              options={this.state.mountingBrackets}
              value={awning.mountingBracketId}
              valueKey={'id'}
              labelKey={'description'}
              imageUrlSelector={(x) => x.pcRef ? `/img/powder_coating_sheet/${x.pcRef}.png` : `/img/powder_coating_sheet/blank.png`}
          />}

          {awning.productId > 0 && this.state.selectedProduct && this.state.selectedProduct.hasAdditionalMountingBrackets &&
              <TextBoxControl
                  onChange={this.handlFieldChange}
                  labelText="Additional Mounting Brackets"
                  value={awning.additionalMountingBrackets.toString()}
                  name="additionalMountingBrackets"
                  type="number"
                  validationMessages={validationMessages}
              />}

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`installationBracketTypeId_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, (v, n) => {
                  return {
                      ...n, awning: {
                          ...n.awning,
                          installationBracketId: null,
                      }
                  };
              }, "number")}
              labelText={`Installation Bracket Type (optional)`}
              validationMessages={validationMessages}
              options={this.state.installationBracketTypes}
              value={awning.installationBracketTypeId}
              onClearSelection={(e) => {
                  e.preventDefault();
                  this.setState({
                      awning:
                          {
                              ...this.state.awning,
                              installationBracketId: null,
                              installationBracketTypeId: null,
                          },
                      installationBrackets: [],
                  }, this.raiseAwningChanged);
              }}
              valueKey={'id'}
              labelKey={'description'}
              imageUrlSelector={(x) => x.pcRef ? `/img/powder_coating_sheet/${x.pcRef}.png` : `/img/powder_coating_sheet/blank.png`}
              visible={this.state.installationBracketTypes && this.state.installationBracketTypes.length > 0}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`installationBracketId_${awning.id}`}
              onChange={(x, e) => {
                  this.handlFieldChangeWithAwningId(e, null, "number");
              }}
              labelText={awning && awning.mountingBracketId === SM_FASCIA_BRACKET_ID ? 'Fascia Bracket Type' : this.state.installationBracketTypes && this.state.installationBracketTypes.length === 1 ? `${this.state.installationBracketTypes[0].description} Installation Bracket` : `Installation Bracket`}
              validationMessages={validationMessages}
              options={this.state.installationBrackets}
              value={awning.installationBracketId}
              valueKey={'id'}
              labelKey={'description'}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`automationSensorType_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, (v, newState) => {
                  return {
                      ...newState, awning: {
                          ...newState.awning,
                          automationSensorType: v == null ? null : v,
                          motionSensorColour: null,
                          includeStabiliserPoles: v == null ? newState.awning.includeStabiliserPoles : false,
                      }
                  };
              }, "number")}
              value={awning.automationSensorType}
              labelText='Automation Sensors'
              onClearSelection={(awning.automationSensorType ? (e) => {
                  e.preventDefault();
                  this.setState({
                      awning: {
                          ...this.state.awning,
                          automationSensorType: null,
                          automationCableId: null,
                          motionSensorColour: null
                      }
                  }, this.raiseAwningChanged);
              } : null)}
              validationMessages={validationMessages}
              options={SensorTypes(awning)}
              visible={(isHardwired(awning) || isRemote(awning)) && !isGeigerRemote(awning) && !isRoofingSystem}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`motionSensorColour_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e)}
              value={awning.motionSensorColour}
              labelText="Motion sensor colour"
              validationMessages={validationMessages}
              options={this.state.motionSensorColours}
              visible={isMotionSensor(awning)}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`automationCableId_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, null, "number")}
              value={awning.automationCableId}
              labelText='Automation Cable'
              validationMessages={validationMessages}
              options={this.state.automationCables}
              visible={(isHardwired(awning) || isRemote(awning))}
          />

          <RadioControlGroup
              style={{marginLeft: '0px'}}
              name={`mocoType_${awning.id}`}
              onChange={(x, e) => this.handlFieldChangeWithAwningId(e, null, "number")}
              value={awning.mocoType}
              labelText='Automation Accessories (optional)'
              onClearSelection={(awning.mocoType ? (e) => {
                  e.preventDefault();
                  this.setState({awning: {...this.state.awning, mocoType: null}}, this.raiseAwningChanged);
              } : null)}
              validationMessages={validationMessages}
              options={this.state.mocoTypes}
              visible={(isHardwired(awning) || isRemote(awning))}
          />
      </div>
    );
  }
}

FabricationAwning.propTypes = {
};

export default FabricationAwning;